import React from 'react';
import { useTranslation } from '../../hx/useTranslation';
import CxChooser from '../../cx/CxChooser';
import CxSnackbar from '../../cx/CxSnackbar';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxFetch from '../../fx/FxFetch';
import '../../../styles/main.css';
import GxForm from '../../gx/GxForm';
import CxIconButton from '../../cx/CxIconButton';
//import { useNav } from '../../hx/useNav';


const MxSettPsReassignTaxForm = (props) => {
  const [{ trans }] = useTranslation();
  //const [{ navBack }] = useNav();
  const r_snack_required = React.useRef(null);
  const r_snack_op_in_progress = React.useRef(null);
  const r_snack_op_successful = React.useRef(null);
  let r_form = React.useRef(null);

  const rf_txTypePsGroup = React.useRef(null);
  const rf_itTaxGroupP = React.useRef(null);
  const rf_itTaxGroupS = React.useRef(null);


  React.useEffect(() => {
    // eslint-disable-next-line
  }, []);

  const doOp = () => {
    // chequea requeridos
    if (rf_txTypePsGroup.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txTypePsGroup.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }
    if (rf_itTaxGroupP.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_itTaxGroupP.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }
    if (rf_itTaxGroupS.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_itTaxGroupS.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }

    let itPsGroup = rf_txTypePsGroup.current.getKey();
    let itTaxGroupP = rf_itTaxGroupP.current.getKey();
    let itTaxGroupS = rf_itTaxGroupS.current.getKey();

    let record = {};
    record['itPsGroup'] = itPsGroup;
    record['itTaxGroupP'] = itTaxGroupP;
    record['itTaxGroupS'] = itTaxGroupS;
    r_snack_op_in_progress.current.setOpen(true);
    Promise.all([FxFetch.doJsonX(`sett/ps/reassign_tax/do`, record)]).then((result) => {
      rf_txTypePsGroup.current.clear();
      rf_itTaxGroupP.current.clear();
      rf_itTaxGroupS.current.clear();
      r_snack_op_in_progress.current.setOpen(false);
      r_snack_op_successful.current.setOpen(true);
    });
  }

  return (
    <div>
      <GxForm
        moduleName={`${trans('field.reassign_x', 'field.tax')}`}
        xref={r_form}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <CxIconButton type="issue" classType="ibs_iconbutton_toolbar" onClick={doOp} tooltip={trans('field.execute')} />
          </div>
        }
      >

        <CxChooser xref={rf_txTypePsGroup}
          label={`${trans('field.group')}`}
          dbfield='t_ps_group.txTypePsGroup' dbfieldkey='n_ps.itPsGroup'
          table="t_ps_group"
          col_id="itPsGroup"
          col_tx="txTypePsGroup"
          filter={`t_ps_group.boActive='${'1'}'`}
          onClear={() => rf_itTaxGroupS.current.clear() }
          required
        />

        <CxChooser xref={rf_itTaxGroupP}
          label={`${trans('field.tax_perc')}-${trans('field.purchases')}`}
          dbfield="t_tax_group.txTypeTaxGroup" dbfieldkey="t_tax_group.itTaxGroup"
          table="t_tax_group"
          col_id="itTaxGroup"
          col_tx="txTypeTaxGroup"
          //filter={`t_tax_group.boActive='${'1'}'`}
          required
        />

        <CxChooser xref={rf_itTaxGroupS}
          label={`${trans('field.tax_perc')}-${trans('field.sales')}`}
          dbfield="t_tax_group.txTypeTaxGroup" dbfieldkey="t_tax_group.itTaxGroup"
          table="t_tax_group"
          col_id="itTaxGroup"
          col_tx="txTypeTaxGroup"
          //filter={`t_tax_group.boActive='${'1'}'`}
          required
        />


      </GxForm>

      <CxSnackbar xref={r_snack_required} severity="error" />
      <CxSnackbar xref={r_snack_op_in_progress} severity="info" value={trans('msg.operation_in_progress')} autoHideDuration={10000} />
      <CxSnackbar xref={r_snack_op_successful} severity="success" value={trans('msg.operation_successful')} />
    </div>
  );

}

export default MxSettPsReassignTaxForm;
